import { render, staticRenderFns } from "./WalletModal.vue?vue&type=template&id=e0b31846&"
import script from "./WalletModal.vue?vue&type=script&lang=ts&"
export * from "./WalletModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports